import React from 'react';
import { ScrollView } from 'react-native';
import { useTranslation } from 'react-i18next';

import { AppText } from '@/components/ui/AppText';
import { BackHeader } from '@/components/ui/BackHeader';
import { Card } from '@/components/ui/Card';
import { Screen } from '@/components/ui/Screen';

function CreditSection({ title, body }: { title: string; body: string }) {
  return (
    <Card className="gap-2 px-4 py-4">
      <AppText variant="heading">{title}</AppText>
      <AppText variant="caption" className="leading-5">
        {body}
      </AppText>
    </Card>
  );
}

export default function CreditsScreen() {
  const { t } = useTranslation();
  return (
    <Screen>
      <BackHeader title={t('credits.title')} />
      <ScrollView contentContainerStyle={{ padding: 16, gap: 12, paddingBottom: 32 }}>
        <CreditSection title={t('credits.dataTitle')} body={t('credits.dataBody')} />
        <CreditSection title={t('credits.ipTitle')} body={t('credits.ipBody')} />
      </ScrollView>
    </Screen>
  );
}
